import AdjustRecallQuantity from './AdjustRecallQuantity';

export default AdjustRecallQuantity;
